import React, { useRef, useState } from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';

const SummaryCards = ({ orderListObj }) => {
  const scrollRef:any = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - scrollRef.current.offsetLeft);
    setScrollLeft(scrollRef.current.scrollLeft);
  };

  const handleMouseLeave = () => setIsDragging(false);
  const handleMouseUp = () => setIsDragging(false);

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX) * 1.5; // scroll speed
    scrollRef.current.scrollLeft = scrollLeft - walk;
  };

  const data = [
    { title: "Total Order", value: orderListObj?.summary_counts?.total_orders || 0 },
    { title: "Total Orders Price", value: `₹ ${(orderListObj?.summary_counts?.total_amounts || 0).toFixed(2)}` },
    { title: "Total Unit Wise Sale", value: orderListObj?.summary_counts?.total_products || 0 },
    { title: "Total Delivered Product", value: orderListObj?.summary_counts?.delivered || 0 },
    { title: "Total Pending Delivery", value: orderListObj?.summary_counts?.total_delivery_pending || 0 },
    { title: "Total Commission Paid", value: "N/A" },
    { title: "Total Commission Pending", value: "N/A" },
  ];

  return (
    <Box
      ref={scrollRef}
      sx={{
        backgroundColor: '#e1eafc',
        overflowX: 'auto',
        whiteSpace: 'nowrap',
        paddingY: 2,
        cursor: isDragging ? 'grabbing' : 'grab',
        userSelect: 'none',
        scrollbarWidth: 'none', // Firefox
        '&::-webkit-scrollbar': { display: 'none' }, // Chrome
      }}
      onMouseDown={handleMouseDown}
      onMouseLeave={handleMouseLeave}
      onMouseUp={handleMouseUp}
      onMouseMove={handleMouseMove}
    >
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'nowrap',
          marginLeft: 2,
          marginRight: 0,
          width:"min-content"
        }}
      >
        {data.map((item, index) => (
          <Box key={`${item.title}-${index}`} sx={{ flex: '0 0 auto', marginRight: 2 }}>
            <Card sx={{ width: 160, height: 80, textAlign: 'center' }}>
              <CardContent>
                <Typography variant="caption" sx={{ fontSize: 10 }}>
                  {item.title}
                </Typography>
                <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: 20 }}>
                  {item.value}
                </Typography>
              </CardContent>
            </Card>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default SummaryCards;
